module.exports = __webpack_public_path__ + "img/7-icono-misordenes-selected.3ed009b4.svg";